export * from './set-tables.action';
